import { isUserOnline } from '../../../features/presence/helpers/isUserOnline';
import Avatar from '../Avatar';

type OnlineAvatarProps = {
  user: any;
  size?: number;
  now?: number;
};

export default function OnlineAvatar({
  user,
  size = 44,
  now = Date.now(),
}: OnlineAvatarProps) {
  return (
    <span className="avatar-presence">
      <Avatar user={user} size={size} />
      {isUserOnline(user, now) && (
        <span className="online-dot" aria-label="Online" title="Online" />
      )}
    </span>
  );
}
